import React from 'react'
import { columnDataTypes, TextThemeType } from '../_config/types'
import { Option } from '../elements/Form/dropdown'
import { trackAction } from '../utils/analytics/rumTracking'
import { APP_ENV, KEYS } from '../_config'
import { cellRenderer } from '../components/cellRenderer'
import toast from 'react-hot-toast'

export const trackEvent = (eventName: string, properties: Record<string, any> = {}) => {
    if (APP_ENV !== 'production' && APP_ENV !== 'qa') return
    trackAction(eventName, {
        ...properties,
        timestamp: new Date().toISOString(),
    })
}

export const createURL = (url: string, params: any) => {
    for (const param of Object.keys(params)) {
        url = url.replace(`:${param}`, params[param])
    }
    return url
}

export const UpdateWithVariables = (url: string, data: any) => {
    if (data) {
        const dynamicParams = url.match(/:[A-Z_]*/gi)
        dynamicParams?.map((key) => {
            if (key.length > 1) url = url.replace(key, data[key.replace(':', '')])
        })
    }
    return url
}

export const getThemedText = (theme: TextThemeType) => {
    switch (theme) {
        case 'primary':
            return 'text-primary'
        case 'secondary':
            return 'text-secondary'
        case 'accent':
            return 'text-accent'
        case 'neutral':
            return 'text-neutral'
        default:
            return 'text-black'
    }
}

export const getUSDFormat = (num: number) => {
    if (num >= 1e9) {
        return '$' + (num / 1e9).toFixed(2) + ' B' // .toFixed(2) for 2 decimal places
    } else if (num >= 1e6) {
        return '$' + (num / 1e6).toFixed(2) + 'M' // .toFixed(2) for 2 decimal places
    } else {
        return '$' + num.toString() // Return the number as a string if it's less than a million
    }
}

export const getSelectedOption = (selectedValue: string | number, options: any[]) => {
    let selected: any = null
    for (const option of options) {
        if (option.value == selectedValue) {
            selected = option
            break
        }
    }
    return selected
}
export const getSelectedOptions = (selectedValues: string[] | number[], options: any[]) => {
    const selected: any[] = []
    selectedValues.map((value) => {
        if (getSelectedOption(value, options)) {
            selected.push(getSelectedOption(value, options))
        }
    })
    return selected
}

export const ConfidenceOption = [
    { label: '80%', value: 80 },
    { label: '85%', value: 85 },
    { label: '90%', value: 90 },
    { label: '95%', value: 95 },
    { label: '99%', value: 99 },
    { label: '99.9%', value: 99.9 },
]

export const serialize = (obj: any) => {
    const str: any = []
    if (obj) {
        for (const key of Object.keys(obj)) {
            str.push(`${key}=${obj[key]}`)
        }
        return str.join('&')
    } else {
        return ''
    }
}
export const addQueryParamsToAPI = (API: string, data: any) => {
    let query: any = data.query
    if (query && Object.keys(query).length > 0) {
        query = serialize(query)
        delete data.query
        API = `${API}?${query}`
    }
    return { API, data }
}

export const getShortUserName = (firstName: string, lastName: string) => {
    return (firstName || '').charAt(0).toUpperCase() + (lastName || '').charAt(0).toUpperCase()
}
export const getFirstCharUpper = (str: string) => {
    return str.charAt(0).toUpperCase() + str.substring(1)
}

export function getDecimalPlacesByRange(arr: number[]): number {
    if (!arr || arr.length === 0) return 2

    const dataRange = Math.max(...arr) - Math.min(...arr)

    if (dataRange === 0) return 2

    // Find the order of magnitude of the range
    const magnitude = Math.floor(Math.log10(Math.abs(dataRange)))

    // Determine decimal places based on magnitude
    if (magnitude >= 2)
        return 2 // Range >= 100
    else if (magnitude >= 0)
        return 2 // Range >= 1
    else if (magnitude >= -2)
        return 3 // Range >= 0.01
    else return Math.min(Math.abs(magnitude) + 2, 8) // Range < 0.01
}

export const convertToKFormat = (num: number, decimalDigit: number = 2): string => {
    const absNum = Math.abs(num) // Get the absolute value

    let formattedNumber

    if (absNum < 1000) {
        formattedNumber = Number.parseFloat(absNum.toFixed(decimalDigit)).toString() // Return the number as is
    } else if (absNum < 1_000_000) {
        formattedNumber = Number.parseFloat((absNum / 1000).toFixed(decimalDigit)) + 'K' // Convert to thousands
    } else if (absNum < 1_000_000_000) {
        formattedNumber = Number.parseFloat((absNum / 1_000_000).toFixed(decimalDigit)) + 'M' // Convert to millions
    } else {
        formattedNumber = Number.parseFloat((absNum / 1_000_000_000).toFixed(decimalDigit)) + 'B' // Convert to billions
    }

    return formattedNumber
}

export function trimZeros(val: string): string {
    return Number.parseFloat(val).toString()
}

export function KMBformatNumber(value: number | string | null | undefined, decimals: number = 2): string {
    if (value === null || value === undefined || value === '') return '0'

    const num = typeof value === 'string' ? Number.parseFloat(value) : value
    if (Number.isNaN(num)) return '0'

    const sign = num < 0 ? '-' : ''
    const absNum = Math.abs(num)

    const units = [
        { value: 1e9, symbol: 'B' },
        { value: 1e6, symbol: 'M' },
        { value: 1e3, symbol: 'K' },
    ]

    for (const unit of units) {
        if (absNum >= unit.value) {
            const printValue: any = trimZeros((absNum / unit.value).toFixed(decimals))
            return (printValue == 0 ? '' : sign) + printValue + unit.symbol
        }
    }

    const printValue: any = trimZeros(absNum.toFixed(decimals))
    console.log('KMB formatNumber ~ ', value, ' => ', (printValue == 0 ? '' : sign) + printValue)
    return (printValue == 0 ? '' : sign) + printValue
}

export function getKPIUnit(kpiName: string, experiment: any): string {
    if (experiment) {
        const unit = experiment.experiment_metadatas.metrices.find((kpi: any) => kpi.literral_value === kpiName)?.kpi_unit
        if (unit) {
            return unit
        } else {
            switch (kpiName) {
                case 'Net Revenue':
                    return 'USD'
                case 'Volumn':
                    return 'HL'
                default:
                    return ''
            }
        }
    } else {
        return ''
    }
}

export const getImpactValue = (kpiName: string, kpiUnit: string, impactVal?: string | number) => {
    if (!impactVal) return '0'

    const value = Number(impactVal)

    if (kpiName === 'Incremental Conversion') {
        return value.toFixed(2) + '%'
    }
    return KMBformatNumber(value) + ` ${kpiUnit || ''}`
}

export const extractTableName = (name: string) => {
    if (typeof name == 'string') {
        const _name = name.split('.')
        return (_name.at(-1) ?? '').trim()
    } else {
        return ''
    }
}

export const formatData = (input: any) => {
    const { xAxis, ...rest } = input // Destructure the input object

    // Create an array of objects
    const formattedArray = xAxis.map((d: string, index: number) => ({
        xAxis: d,
        ...Object.keys(rest).reduce((a: any, c: string) => {
            a[c] = rest[c][index]
            return a
        }, {}),
        // control: Control[index],
        // test: Test[index],
    }))

    return formattedArray
}
export function getRandomColor() {
    const letters = '0123456789ABCDEF'
    const randomValues = new Uint8Array(6)
    crypto.getRandomValues(randomValues)
    let color = '#'
    for (let i = 0; i < 6; i++) {
        color += letters[randomValues[i] % 16]
    }
    return color
}

export const handleNumberInputChange = (e: React.ChangeEvent<HTMLInputElement>, min: number | '' = '', max: number | '' = '', allowDecimal: boolean = false, allowNegative: boolean = false) => {
    let n: any = e.target.value
    n = sanitizeInput(n, allowDecimal, allowNegative)

    if (n !== '' && n !== '-') {
        n = applyMinMax(n, min, max)
    }

    return n
}

const sanitizeInput = (value: string, allowDecimal: boolean, allowNegative: boolean): string => {
    // Build allowed characters dynamically using String.raw
    let allowedChars = String.raw`\d` // digits
    if (allowDecimal) allowedChars += String.raw`\.` // decimal point
    if (allowNegative) allowedChars += String.raw`\-` // minus sign

    // Create regex to match anything NOT allowed
    const regex = new RegExp(`[^${allowedChars}]`, 'g')

    return value.replace(regex, '')
}

const applyMinMax = (value: string, min: number | '', max: number | ''): string | number => {
    const num = Number.parseFloat(value)
    if (typeof min === 'number' && num < min) return min
    if (typeof max === 'number' && num > max) return max
    return value
}

export const createOptionsFromStringArray = (arr: string[] | null) => {
    if (arr) {
        const ARR = arr.toSorted((a, b) => a.localeCompare(b))
        return ARR.map((str: string) => {
            return { label: str, value: str }
        })
    } else {
        return []
    }
}

export const filteredOption = (options: Option[], own: Option[], removedOptions: Option[]) => {
    const availableOptions = options.filter((opt) => {
        let used = false
        let ownUsed = false

        for (const ownOpt of own) {
            if (ownOpt?.value == opt?.value) {
                ownUsed = true
                break
            }
        }

        if (!ownUsed) {
            for (const _selected of removedOptions) {
                if (_selected?.value == opt?.value) {
                    used = true
                    break
                }
            }
        }

        return !used
    })
    return availableOptions
}

export const copyToClipboard = async (text: string) => {
    try {
        await navigator.clipboard.writeText(text)
    } catch (err) {
        console.error('Failed to copy:', err)
    }
}

export const formatNumberIndianStyle = (data: number) => {
    // Convert the data to a string
    const numStr = data.toString()

    // Split into integer and decimal parts
    const [integerPart, decimalPart] = numStr.split('.')

    if (!integerPart) return numStr

    const n = integerPart
    const lastThree = n.slice(-3)
    let otherDigits = n.slice(0, -3)
    const parts: string[] = []

    // Split remaining digits in groups of 2
    while (otherDigits.length > 2) {
        parts.unshift(otherDigits.slice(-2))
        otherDigits = otherDigits.slice(0, -2)
    }
    if (otherDigits) parts.unshift(otherDigits)

    const formattedInteger = parts.length ? parts.join(',') + ',' + lastThree : lastThree

    // Combine with decimal part if exists
    return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger
}

export const formatNumberWithCommas = (data: number) => {
    return Intl.NumberFormat('en-US').format(data ?? 0)
}

// Formats ATE (Average KPI Lift) values per spec: whole numbers show no decimals,
// |value| >= 1 rounds to 3 decimals, |value| < 1 keeps digits through the first 3 non-zero decimals.
// Null/undefined/empty => '-'. Non-numeric strings (for example 'NA') are preserved as-is.
// Preserves sign. Never displays '0' for a non-zero input.
export const formatATE = (value: any): string => {
    if (value === null || value === undefined || value === '') return '-'

    if (typeof value === 'string') {
        const trimmedValue = value.trim()

        if (trimmedValue === '') return '-'

        const parsedValue = Number(trimmedValue)
        if (!Number.isFinite(parsedValue)) return trimmedValue

        value = parsedValue
    }

    const n = typeof value === 'number' ? value : Number(value)
    if (!Number.isFinite(n)) return '-'
    if (n === 0) return '0'

    const sign = n < 0 ? '-' : ''
    const abs = Math.abs(n)

    if (Number.isInteger(abs)) return `${sign}${abs}`

    if (abs >= 1) {
        const rounded = Math.round(abs * 1000) / 1000
        return `${sign}${rounded}`
    }

    const leadingZeros = -Math.floor(Math.log10(abs)) - 1
    const totalDecimals = leadingZeros + 3
    const fixed = abs.toFixed(totalDecimals)
    // Strip trailing zeros, then a lone trailing dot, in a single anchored pass.
    const trimmed = fixed.replace(/\.(\d*[1-9])?0+$/, (_, keep) => (keep ? `.${keep}` : ''))

    // Guard against representations that would round the visible value down to 0.
    if (Number(trimmed) === 0) return `${sign}${fixed}`
    return `${sign}${trimmed}`
}

export const makeUniqueOptionArray = (options: any[]) => {
    const OPTIONS = options.toSorted((a: any, b: any) => {
        if (typeof a == 'string') {
            return a.localeCompare(b)
        } else {
            return a.label.localeCompare(b.label)
        }
    })
    const uniqueOptions = Array.from(new Map(OPTIONS.map((item: any) => [item.value, item])).values())
    return uniqueOptions
}

export const sortOptions = (options: any) => {
    if (options) {
        return options.toSorted((a: any, b: any) => a.label.localeCompare(b.label))
    } else {
        return options
    }
}

export const getQueryString = (obj: any): string => {
    return Object.keys(obj)
        .map((key: string) => `${key}=${obj[key]}`)
        .join('&')
}
export const getValueByLabel = (value: any, uniquearr: any) => {
    const found = uniquearr.find((item: any) => item.value === value)
    return found ? found.value : ''
}
export const getDescByLabel = (value: any, uniquearr: any) => {
    const found = uniquearr.find((item: any) => item.value === value)
    return found ? found.desc : ''
}
export const getExampleByLabel = (value: any, uniquearr: any) => {
    const found = uniquearr.find((item: any) => item.value === value)
    return found ? found.example : ''
}

export const isBuisenessOwnerRepectToExperiment = (experiment: any, user_literal: string) => {
    const businessOwner = JSON.parse(localStorage.getItem(KEYS.BUSINESS_OWNER) || '{}')
    const experimentBusinessFunction = experiment?.business_function?.business_function_literal || ''
    const experimentCountry = experiment?.country?.country_literal || ''
    const experimentUseCase = experiment?.use_case?.use_case_literal || ''
    let isOwner: boolean = false
    if (Array.isArray(businessOwner) && businessOwner.length > 0) {
        for (const owner of businessOwner) {
            if (owner.user_type == 'GHQ' || (owner.business_function?.business_function_literal == experimentBusinessFunction && owner.country?.country_literal == experimentCountry && owner.use_case?.use_case_literal == experimentUseCase)) {
                isOwner = true
            }
        }
    } else if (typeof businessOwner === 'object' && businessOwner !== null) {
        if (businessOwner.business_function?.business_function_literal == experimentBusinessFunction && businessOwner.country?.country_literal == experimentCountry && businessOwner.use_case?.use_case_literal == experimentUseCase) {
            isOwner = true
        }
    }

    return isOwner
}

export const isMyExperiment = (experiment: any, user_literal: string) => {
    return experiment?.user?.user_literal == user_literal
}

export const validateDecimals = (value: any) => {
    if (value === '') return true
    const num = Number.parseFloat(value)
    if (Number.isNaN(num)) return 'Must be a number'
    const decimalPart = value.toString().split('.')[1]
    return !decimalPart || decimalPart.length <= 2 || 'Maximum of 2 decimal places allowed'
}

export const decodeJWT = (token: string) => {
    if (!token) {
        throw new Error('Token is empty or undefined')
    }

    const parts = token.split('.')
    if (parts.length !== 3) {
        throw new Error('JWT token does not have 3 parts')
    }

    const base64Url = parts[1]
    let base64 = base64Url.replaceAll('-', '+').replaceAll('_', '/')

    // Add padding '=' if missing
    while (base64.length % 4 !== 0) {
        base64 += '='
    }

    try {
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => {
                    return '%' + ('00' + (c.codePointAt(0) ?? 0).toString(16)).slice(-2)
                })
                .join(''),
        )

        return JSON.parse(jsonPayload)
    } catch (error) {
        throw new Error('Failed to decode base64 payload: ' + (error as Error).message)
    }
}
export const getUpLiftValue = (value: any, type: string) => {
    if (type === 'data') {
        if (value === 0) return '0%'
        if (value) return `${formatNumberWithCommas(value.toFixed(2))}%`
        return '-'
    } else if (type === 'color') {
        if (value == 0) return '!text-[#DBC848]'
        if (value && value > 0) return `!text-[#28A526]`
        if (value && value < 0) return `!text-[#F23F44]`
        return ''
    }
    return null
}

export const getColor = (status: string) => {
    let Color = 'grey'
    if (status == 'Negative Lift') {
        Color = 'red'
    } else if (status == 'Passed') {
        Color = 'green'
    } else if (status == 'Inconclusive') {
        Color = 'orange'
    } else if (status === 'Positive Lift') {
        Color = 'green'
    } else if (status === 'Running') {
        Color = 'orange'
    } else if (status === 'Submitted') {
        Color = 'blue'
    } else if (status === 'No Impact') {
        Color = 'orange'
    }

    return Color
}

export const changeToAddFilterTab = (experiment: any, setFilterTab: any, getFilterPreviwData: any, setFilters: any, setSqls: any) => {
    if (experiment?.user_design == null) {
        setFilterTab('filter')
        getFilterPreviwData()
        setFilters(null)
        setSqls(null)
    }
}

export const getColumnDef = (data: any[]) => {
    return Object.keys(data[0]).map((key: string, i: number) => {
        return {
            headerName: key,
            field: key,
            filter: false,
            sortable: false,
            suppressMenu: true,
            cellStyle: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
            cellRenderer,
        }
    })
}

export const makeColumn = (key: string, i: number) => {
    return {
        headerName: key,
        field: key,
        filter: false,
        sortable: false,
        suppressMenu: true,
        headerClass: 'data-preview-header',
        cellStyle: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        cellRenderer,
    }
}

export const getTableDataResponseHandler = (data: any, resolve: any) => {
    const sampSizeTotal = data?.data?.total
    const rawResult = data?.data?.result ?? []
    const rowData = rawResult.filter((row: any) => row && typeof row === 'object').map(normalizeRowValues)
    const firstRow: Record<string, unknown> = rowData[0] ?? {}
    const columnDefs: any = Object.keys(firstRow).map((key: string, i: number) => {
        return {
            headerName: key,
            field: key,
            filter: false,
            sortable: false,
            suppressMenu: true,
            headerClass: 'data-preview-header',
            cellStyle: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
            cellRenderer,
        }
    })
    resolve({ columnDefs, rowData, sampSizeTotal })
}

export const stringifyCellValue = (value: unknown): unknown => {
    if (value === null || value === undefined) return value
    if (typeof value === 'object') {
        try {
            return JSON.stringify(value)
        } catch {
            // Fallback for values JSON.stringify rejects (circular refs, BigInt).
            const seen = new WeakSet<object>()
            return JSON.stringify(value, (_key, val) => {
                if (typeof val === 'bigint') return val.toString()
                if (typeof val === 'object' && val !== null) {
                    if (seen.has(val)) return '[Circular]'
                    seen.add(val)
                }
                return val
            })
        }
    }
    return value
}

export const normalizeRowValues = <T extends Record<string, unknown>>(row: T): Record<string, unknown> => {
    const normalized: Record<string, unknown> = {}
    for (const [key, value] of Object.entries(row)) {
        normalized[key] = stringifyCellValue(value)
    }
    return normalized
}

export const processDataColumnResponse = (experiment: any, data: any, setcolumnDefs: any, setRowData: any, setcolumnPreviewData: any, hideLoader: any) => {
    if (data.length > 0) {
        const rows = data.filter((row: any) => row && typeof row === 'object').map(normalizeRowValues)

        if (rows.length === 0) {
            setcolumnDefs([])
            setRowData([])
            toast.error('No results found for the specified query. Please adjust your conditions.')
            hideLoader()
            return
        }

        const columnDefs: any = getColumnDef(rows)
        setcolumnDefs(columnDefs)
        setRowData(rows)
        setcolumnPreviewData(Object.keys(rows[0]) as any)
    } else {
        setRowData([])
        toast.error('No results found for the specified query. Please adjust your conditions.')
    }
    hideLoader()
}
export const experimentTableHeaderClass = (params: any) => {
    const data: any = params?.column?.colDef?.filterParams?.selectedFilters
    const key: any = params?.column?.colDef?.filterParams?.filterKey || params?.column?.colDef?.filterParams?.columnKey
    if (data && key) {
        const value = data[key]
        if (value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0)) {
            return 'summery-experiment-header'
        }
        return 'summery-experiment-header ag-header-cell-filtered'
    } else {
        return 'summery-experiment-header'
    }
}

export const objectToQueryParams = (params: Record<string, any>): string => {
    const queryString = Object.entries(params)
        .filter(([_, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
        .join('&')

    return queryString ? `?${queryString}` : ''
}

export const Max50 = (value: any, experiment: any) => {
    // If not selected anything → valid
    if (!value || value.length === 0) return true

    const columnCounts: any = experiment?.experiment_metadatas?.design_data_quality_report?.columns_unique_count || {}

    // Loop over selected items
    for (const col of value) {
        const colName = col?.label
        if (!colName) continue

        if (columnCounts[colName] > 50) {
            return `${colName} column must have unique count ≤ 50`
        }
    }

    return true
}

export const toLocalISOString = (date: any) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}T00:00:00`
}

/** Formats uplift number as percentage string */
export const formatUplift = (uplift: number | null): string => {
    if (uplift === null || uplift === undefined) return '-'
    const nprefix = Number(uplift.toFixed(2)) < 0 ? '-' : ''
    const prefix = Number(uplift.toFixed(2)) > 0 ? '+' : nprefix
    return `${prefix}${Math.abs(Number(uplift.toFixed(2)))}%`
}

export const getColumnNames = (columns: Record<columnDataTypes, string[]> | null, dataTypes: columnDataTypes[], common: boolean = false, alreadyUsed: Option[] = []): string[] => {
    if (!columns) return []
    const columnNames: string[] = []

    if (dataTypes.includes('all')) {
        ;(Object.keys(columns) as columnDataTypes[]).forEach((key: columnDataTypes) => {
            columnNames.push(...columns[key])
        })
    } else if (common) {
        const commonColumns = dataTypes.map((dataType) => columns[dataType] || [])
        if (commonColumns.length > 0) {
            const [first, ...rest] = commonColumns
            columnNames.push(...first.filter((col) => rest.every((arr) => arr.includes(col))))
        }
    } else {
        for (const dataType of dataTypes) {
            if (columns[dataType]) {
                columnNames.push(...columns[dataType])
            }
        }
    }

    if (alreadyUsed.length > 0) {
        const filteredColumnNames = columnNames.filter((col) => !alreadyUsed.some((option) => option.label === col))
        return [...new Set(filteredColumnNames)]
    }

    return [...new Set(columnNames)]
}

export const getColumnNamesAsOptions = (columns: Record<columnDataTypes, string[]> | null, dataTypes: columnDataTypes[], common: boolean = false, alreadyUsed: Option[] = []): Option[] => {
    if (!columns) return []
    const columnNames = getColumnNames(columns, dataTypes, common, alreadyUsed)
    return columnNames.map((name) => ({ label: name, value: name }))
}
